import { LibraryBooksOutlined } from '@mui/icons-material';
import { CuriosityNamespaceType } from '@procureai/curiosity-ui-mui';

import { SearchHitSourcingProject } from '../../components/SearchHitSourcingProject/SearchHitSourcingProject.tsx';
import { SearchRefinementListItemCuriosity } from '../../components/SearchRefinementListItemCuriosity/SearchRefinementListItemCuriosity.tsx';
import { SearchRefinementListItemI18n } from '../../components/SearchRefinementListItemI18n/SearchRefinementListItemI18n.tsx';
import { SearchDateRange } from '../../filters/SearchDateRange/SearchDateRange.tsx';
import { SearchRefinementList } from '../../filters/SearchRefinementList/SearchRefinementList.tsx';
import { FacetVariant } from '../../types/FacetVariant.ts';
import { SearchConfigItem } from '../../types/SearchConfigItem.ts';
import { SearchFilterAttribute } from '../../types/SearchFilterAttribute.ts';
import { SearchIndex } from '../../types/SearchIndex.ts';
import { SearchIndexConfigFactoryOptions } from '../../types/SearchIndexConfigFactoryOptions.ts';
import { createSearchFilterAttributeItem } from '../../util/createSearchFilterAttributeItem.ts';
import { createSearchSortByItemValue } from '../../util/createSearchSortByItemValue.ts';
import { toNumberRangeRouteValue } from '../../util/mapStateToRoute.ts';

const indexName = SearchIndex.SOURCING_PROJECT;

export const sourcingProjectSearchIndexConfig = ({ t }: SearchIndexConfigFactoryOptions): SearchConfigItem => {
  return {
    title: t('indexes.sourcingProject.title'),
    description: t('indexes.sourcingProject.description'),
    icon: LibraryBooksOutlined,
    indexName,
    slug: 'src',
    hitComponent: SearchHitSourcingProject,
    filters: [
      createSearchFilterAttributeItem({
        attribute: SearchFilterAttribute.SOURCING_PROJECT_STATUS,
        slug: 'status',
        facetVariant: FacetVariant.REFINEMENT_LIST,
        component: SearchRefinementList,
        componentProps: {
          title: t('filter.status.title'),
          itemComponent: SearchRefinementListItemI18n,
          itemComponentProps: {
            keyPrefix: 'Base.sourcingProject.status',
          },
        },
      }),
      createSearchFilterAttributeItem({
        attribute: SearchFilterAttribute.SOURCING_PROJECT_VARIANT,
        slug: 'variant',
        facetVariant: FacetVariant.REFINEMENT_LIST,
        component: SearchRefinementList,
        componentProps: {
          title: t('filter.variant.title'),
          itemComponent: SearchRefinementListItemI18n,
          itemComponentProps: {
            keyPrefix: 'Base.sourcingProject.variant',
          },
        },
      }),
      createSearchFilterAttributeItem({
        attribute: SearchFilterAttribute.CREATED_AT,
        slug: 'created',
        facetVariant: FacetVariant.RANGE,
        component: SearchDateRange,
        componentProps: {
          title: t('filter.createdAt.title'),
        },
        valueStateToRoute: toNumberRangeRouteValue,
      }),
      createSearchFilterAttributeItem({
        attribute: SearchFilterAttribute.SOURCING_PROJECT_SUPPLIER_IDS,
        slug: 'supplier',
        facetVariant: FacetVariant.REFINEMENT_LIST,
        component: SearchRefinementList,
        componentProps: {
          title: t('filter.supplier.title'),
          itemComponent: SearchRefinementListItemCuriosity,
          itemComponentProps: {
            ns: CuriosityNamespaceType.SUPPLIER,
          },
        },
      }),
      createSearchFilterAttributeItem({
        attribute: SearchFilterAttribute.SOURCING_PROJECT_COMMODITY_GROUP_ID,
        slug: 'commodity-group',
        facetVariant: FacetVariant.REFINEMENT_LIST,
        component: SearchRefinementList,
        componentProps: {
          title: t('filter.commodityGroup.title'),
          itemComponent: SearchRefinementListItemCuriosity,
          itemComponentProps: {
            ns: CuriosityNamespaceType.COMMODITY_GROUP,
          },
        },
      }),
    ],
    sortByItems: [
      {
        label: t('sortBy.relevance'),
        value: createSearchSortByItemValue(indexName),
        slug: 'relevance',
        isDefault: true,
      },
      {
        label: t('sortBy.createdAtAsc'),
        value: createSearchSortByItemValue(indexName, SearchFilterAttribute.CREATED_AT),
        slug: 'created-at:asc',
      },
      {
        label: t('sortBy.createdAtDesc'),
        value: createSearchSortByItemValue(indexName, SearchFilterAttribute.CREATED_AT, true),
        slug: 'created-at:desc',
      },
    ],
    groupBy: 'sourcingProject.id',
    groupLimit: 1,
  };
};
